import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PCODPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for PCOD (Polycystic Ovarian Disease)</h1>
        <section className="mb-8">
          <p>PCOD is a hormonal disorder affecting women of reproductive age, characterized by irregular periods, ovarian cysts, and hormonal imbalances. Our natural therapies focus on restoring hormonal balance, improving ovarian function, and supporting overall reproductive health through gentle, effective herbal remedies and lifestyle modifications.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Hormonal imbalances</li>
            <li>Insulin resistance</li>
            <li>Genetic predisposition</li>
            <li>Obesity</li>
            <li>Stress and lifestyle factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Irregular menstrual cycles</li>
            <li>Weight gain</li>
            <li>Acne and oily skin</li>
            <li>Excess facial or body hair</li>
            <li>Difficulty conceiving</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use hormone-balancing herbs, metabolic regulators, and lifestyle modifications to naturally treat PCOD. Our approach focuses on restoring hormonal balance, improving ovarian function, and supporting overall reproductive health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural hormone balance</li>
            <li>Improved menstrual regularity</li>
            <li>Enhanced fertility</li>
            <li>No harsh side effects</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain a healthy weight</li>
            <li>Eat a balanced, low-glycemic diet</li>
            <li>Exercise regularly</li>
            <li>Manage stress levels</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement in PCOD symptoms?</strong>
            <p>A: Many women notice improvement within 2-3 months of consistent treatment and lifestyle changes.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for women trying to conceive?</strong>
            <p>A: Yes, our natural remedies are safe and can support fertility and reproductive health.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment help with weight management?</strong>
            <p>A: Yes, our holistic approach includes dietary and lifestyle guidance to support healthy weight management.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from PCOD—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default PCODPage; 